export default "__VITE_ASSET__83c49c31__"